export default "__VITE_ASSET__CfVR03fw__"